import { Paper, styled } from "@mui/material";

export const Tool = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    width: 200,
    height: 200,
    lineHeight: '200px',
    margin: "10px auto",
    cursor: "move"
}));